const fixedHeader = {
  data: () => {
    return {
      fixedPart: null,
      fixedPartHeight: 0,
    };
  },
  created() {
    this.$nextTick(() => {
      this.fixedPart = document.querySelector('.fixed-part');
      if (this.fixedPart) {
        if (Array.isArray(this.fixedPart)[0]) {
          this.fixedPart = this.fixedPart[0];
        }
        window.addEventListener('resize', () => {
          this.useFixedPart();
        });

        window.addEventListener('scroll', () => {
          if (window.scrollY > this.fixedPartHeight) {
            this.fixedPart.classList.add('body-scrolled');
          } else {
            this.fixedPart.classList.remove('body-scrolled');
          }
          setTimeout(() => {
            this.useFixedPart();
          }, 1000);
        });
      }
    });
  },
  mounted: function() {

    this.$nextTick(() => {
      if (this.fixedPart) {
        this.useFixedPart();
      }
    });
  },
  methods: {
    useFixedPart() {
      if (!this.fixedPart) return;

      this.fixedPartHeight = this.fixedPart.clientHeight;

      const parentEl = this.fixedPart.parentElement;
      if (this.fixedPartHeight + 'px' !== parentEl.style.paddingTop) {
        parentEl.style.paddingTop = this.fixedPartHeight + 'px';
      }
    },
  },
};

export default fixedHeader;
